import { render, staticRenderFns } from "./firstStep.vue?vue&type=template&id=fd72efaa&scoped=true&"
import script from "./firstStep.vue?vue&type=script&lang=js&"
export * from "./firstStep.vue?vue&type=script&lang=js&"
import style0 from "./firstStep.vue?vue&type=style&index=0&id=fd72efaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd72efaa",
  null
  
)

export default component.exports